<script setup lang="ts">
  import { IconScanAlarm, Button } from "@ui-kit";
  import { default as Wrapper } from "./Wrapper.vue";

  const emit = defineEmits<{ (e: "click:cancel"): void }>();
</script>

<template>
  <Wrapper :title="$t('Приложите hard tag<br />к RFID сканеру')" :subtitle="$t('и дождитесь завершения записи')">
    <template #icon>
      <IconScanAlarm />
    </template>
    <template #buttons>
      <Button variant="secondary" @click="emit('click:cancel')" data-testid="alarming-btn-cancel">{{ $t("Отмена") }}</Button>
    </template>
  </Wrapper>
</template>
